import React from "react";

const MessageInput = ({ 
  value, 
  onChange, 
  onSubmit, 
  placeholder = "Type your message...",
  isLoading = false,
  // Keep backwards compatibility
  newMessage,
  setNewMessage,
  onSendMessage,
  disabled = false
}) => {

  // Use new prop names if provided, otherwise fall back to old ones
  const messageValue = value !== undefined ? value : newMessage;
  const handleChange = onChange ? (e) => onChange(e.target.value) : ((e) => setNewMessage && setNewMessage(e.target.value));
  const handleSubmit = onSubmit || onSendMessage;
  const isDisabled = isLoading || disabled;

  // Safe function to check if message has content
  const hasValidMessage = () => {
    return messageValue && typeof messageValue === 'string' && messageValue.trim().length > 0;
  };

  return (
    <div className="bg-white border-t border-gray-200 p-4">
      <form
        onSubmit={handleSubmit}
        className="flex items-center space-x-4"
      >
        <input
          type="text"
          value={messageValue || ''}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={isDisabled}
          className="flex-1 border border-gray-200 rounded-full px-6 py-3 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <button
          type="submit"
          disabled={isDisabled || !hasValidMessage()}
          className="bg-[#F15213] text-white rounded-full p-3 hover:bg-[#d14711] focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
            />
          </svg>
        </button>
      </form>
    </div>
  );
};

export default MessageInput; 